/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createResultSet } from '../../factoriesAny.js';
export var ResultSetDependencies = {
  createResultSet
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesResultSet.generated.js
// module id = null
// module chunks = 